import Swiper, { Autoplay, Pagination } from 'swiper';
import 'swiper/css';
import { domContentLoadEvent } from '../common/domContentLoadEvent';

function initializeBanner(bannerElement) {
    const swiperPagination = bannerElement.querySelector('.swiper-pagination');
    const progressBar = bannerElement.querySelector('.swiper-pagination');

    new Swiper(bannerElement.querySelector('.swiper'), {
        modules: [Pagination, Autoplay],
        slidesPerView: 1,
        loop: true,

        autoplay: {
            delay: 8000,
            disableOnInteraction: false,
        },
        pagination: {
            el: swiperPagination,
            clickable: true,
            renderBullet: function (index, className) {
                return (
                    '<span class="swiper-pagination-bullet">' +
                    ' <span>' +
                    (index + 1).toString().padStart(2, '0') +
                    '</span>' +
                    ' <div class="progress"><span class="progress-bar"></span></div> ' +
                    '</span>'
                );
            },
        },
        on: {
            autoplayTimeLeft(s, time, progress) {
                progressBar.style.setProperty('--progress', 1 - progress);
                // progressContent.textContent = `${Math.ceil(time / 1000)}s`;
            },
            init: function (sw) {
                domContentLoadEvent(function () {
                    updateLazyVideo(sw, bannerElement);
                });
            },
            slideChange: function (sw) {
                updateLazyVideo(sw, bannerElement);
            },
        },
    });
}

function initializeAllBanners() {
    document.querySelectorAll('.banner').forEach(function (element) {
        initializeBanner(element);
    });
}

function updateLazyVideo(sw, rootComponent) {
    // Stop all
    var videoSources = rootComponent.querySelectorAll('video source');
    videoSources.forEach(function (elem) {
        elem.setAttribute('src', '');
    });

    // Run current
    var current = rootComponent.querySelector('.swiper-slide:nth-child(' + (sw.activeIndex + 1) + ')');

    if (current && current.querySelector('video')) {
        var video = current.querySelector('video source');

        if (video) {
            video.setAttribute('src', video.dataset.src);
            current.querySelector('video').load();
        }
    }
}

domContentLoadEvent(initializeAllBanners);
